import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { sessionReducer } from 'redux-react-session';
import authReducer from "./AuthReducer"
import appReducer from "./AppReducer";
import rstReducer from "./RestaurantReducer"
import plcReducer from "./PlaceReducer"
import usrReducer from "./UserReducer"
import rolReducer from "./RolReducer"
import ntfReducer from "./NotificationReducer"
import nvtReducer from "./NoveltyReducer"
import stsReducer from "./StatsReducer"
import dvyReducer from "./DeliveryBoyReducer"
const rootReducer = combineReducers({
	form: formReducer,
	auth: authReducer,
	app: appReducer,
	evt: rstReducer,
	plc: plcReducer,
	usr: usrReducer,
	rol: rolReducer,
	ntf: ntfReducer,
	nvt: nvtReducer,
	sts: stsReducer,
	ses: sessionReducer,
	dvy: dvyReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js